import { MANDATE_CONTRACT_TYPE, TARIFF_TRANSLATION } from '../models/finex';
// map rest api response values to UI display values

// mandateContractType: 'taxi' | 'delivery' | null
export const mapMandateContractType = mandateContractType => {
  if (mandateContractType === MANDATE_CONTRACT_TYPE.TAXI) {
    return 'Такси';
  }

  if (mandateContractType === MANDATE_CONTRACT_TYPE.DELIVERY) {
    return 'Доставка';
  }

  return 'Нет даных для типа zlecenia';
};

// time: 0.125 | 0.25 | 1 | null
export const mapMandateContractTime = time => {
  if (time === 1) {
    return 'Pełny etat';
  }

  if (time === 0.25) {
    return '1/4 etatu';
  }

  if (time === 0.125) {
    return '1/8 etatu';
  }

  return 'Нет даных для etat';
};

export const mapTariffs = (tariffs, options = {}) => {
  if (!tariffs) return [];

  const mappedTariffs = tariffs.map(
    tariff => TARIFF_TRANSLATION[tariff] || tariff
  );

  if (options?.addNewLine) {
    return mappedTariffs.join(',\n ');
  }

  return mappedTariffs;
};
